import React from "react";

const SsoAvgTat = ({ data }) => {

  if (!data || data.length === 0) {
    return (
      <div className="p-4 text-center text-gray-600">
        No data available to display.
      </div>
    );
  }

  const ssoNames = data.map((item) => item.sso);
  const transformedRow = { SSO: "AVG TAT (Hrs)" };

  data.forEach((item) => {
    transformedRow[item.sso] = item.avg_tat;
  });

  const headers = ["SSO", ...ssoNames];
  const tableData = [transformedRow];

  return (
    <div className="w-full p-4 font-sans overflow-x-auto overflow-y-auto max-h-[400px]">
      <table className="min-w-[1000px] border-collapse border border-gray-300 overflow-hidden shadow-lg">
        <thead className="text-sm">
          <tr>
            {headers.map((header, colIdx) => (
              <th
                key={header}
                className={`border border-gray-300 p-3 text-center whitespace-nowrap text-gray-700
                  ${colIdx === 0
                    ? "bg-gray-200 font-bold"
                    : "bg-gray-100"
                  }`}
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((rowData, rowIndex) => (
            <tr key={rowIndex}>
              {headers.map((key, colIdx) => (
                <td
                  key={key}
                  className={`border border-gray-300 p-3 text-center whitespace-nowrap text-sm
                    ${colIdx === 0
                      ? "bg-gray-200 font-semibold text-gray-700"
                      : rowIndex === 0 && colIdx !== 0
                        ? "text-red-600"
                        : ""
                    }
                    ${colIdx !== 0 && colIdx % 2 === 0
                      ? "bg-gray-50"
                      : colIdx !== 0
                        ? "bg-white"
                        : ""
                    }`}
                >
                  {rowData[key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SsoAvgTat;
